/* ============================================================
   Vesperale header: mobiele menu-drawer
   Vanilla JS, geen framework. Toggle, aria-expanded, focus-trap,
   ESC-sluit, scroll-lock, reduced-motion, focus-return.
   ============================================================ */
(function () {
  function initHeaderDrawer() {
    var root = document.querySelector('[data-drawer-root]');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var drawer = root.querySelector('#vesp-drawer');
    if (!drawer) return;

    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = root.querySelectorAll('[data-drawer-close]');
    var lastFocused = null;
    var FOCUSABLE = 'a[href], button:not([disabled]), summary, input, [tabindex]:not([tabindex="-1"])';

    function isOpen() {
      return root.classList.contains('is-open');
    }

    function visibleFocusables() {
      return Array.prototype.slice.call(drawer.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function open() {
      if (isOpen()) return;
      lastFocused = document.activeElement;
      root.hidden = false;
      void root.offsetWidth; /* reflow forceren zodat de transition pakt */
      root.classList.add('is-open');
      document.documentElement.classList.add('vesp-drawer-open');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      var closeBtn = drawer.querySelector('.vesp-drawer-close');
      var first = closeBtn || visibleFocusables()[0];
      if (first) first.focus();
      document.addEventListener('keydown', onKeydown, true);
    }

    function close() {
      if (!isOpen()) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('vesp-drawer-open');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      document.removeEventListener('keydown', onKeydown, true);

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        root.hidden = true;
      } else {
        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          drawer.removeEventListener('transitionend', finish);
          root.hidden = true;
        };
        drawer.addEventListener('transitionend', finish);
        setTimeout(finish, 420);
      }
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(e) {
      if (!isOpen()) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var nodes = visibleFocusables();
      if (!nodes.length) return;
      var firstEl = nodes[0];
      var lastEl = nodes[nodes.length - 1];
      var active = document.activeElement;
      if (!drawer.contains(active)) {
        e.preventDefault();
        firstEl.focus();
        return;
      }
      if (e.shiftKey && active === firstEl) {
        e.preventDefault();
        lastEl.focus();
      } else if (!e.shiftKey && active === lastEl) {
        e.preventDefault();
        firstEl.focus();
      }
    }

    openers.forEach(function (o) {
      o.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    closers.forEach(function (c) {
      c.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });

    // Submenu-toggle: de titel-link navigeert, alleen de pijl-knop klapt de sub uit.
    var subToggles = drawer.querySelectorAll('[data-drawer-subtoggle]');
    subToggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var group = btn.closest('[data-drawer-group]');
        if (!group) return;
        var sub = group.querySelector('.vesp-drawer-sub');
        var willOpen = !group.classList.contains('is-open');
        group.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (sub) sub.hidden = !willOpen;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderDrawer);
  } else {
    initHeaderDrawer();
  }
  document.addEventListener('shopify:section:load', initHeaderDrawer);
})();
